<template>
  <div class="pTop">
    <v-responsive width="100%">
      <agile
        v-if="loading"
        key="loadingCarousel"
        ref="loadingCarousel"
        :options="myOptions"
      >
        <v-responsive
          :aspect-ratio="16 / 9"
          v-if="loading"
          class="d-flex justify-center align-center"
        >
          <v-progress-circular
            indeterminate
            color="var(--gray-2)"
          ></v-progress-circular>
        </v-responsive>
      </agile>
      <agile v-if="!loading" ref="carousel" :options="myOptions">
        <v-card
          v-for="(banner, i) in banners"
          :key="`banner_${banner.id}-${i}`"
          flat
          tile
          class="d-flex justify-center"
          :to="!banner.openInNew ? banner.to : ''"
          :href="banner.openInNew ? banner.to : ''"
          :target="banner.openInNew ? '_blank' : '_self'"
        >
          <v-img
            class="pTop-Bunner"
            contain
            aspect-ratio="1.7777778"
            :alt="banner.title"
            :src="banner.src"
          >
          </v-img>
        </v-card>
        <template slot="prevButton">
          <v-icon>chevron_left</v-icon>
        </template>
        <template slot="nextButton">
          <v-icon>chevron_right</v-icon>
        </template>
      </agile>
    </v-responsive>

    <div class="pTop-Container">
      <Add01 />
    </div>

    <div class="pTop-Container">
      <NewsWidget
        v-if="showChoices"
        :pastCpLink="true"
        :countPosts="3"
      ></NewsWidget>

      <v-sheet max-width="1000" class="mx-auto mt-4">
        <v-row>
          <v-col v-for="item in miniBannerList" :key="item.id" cols="12" md="4">
            <v-card
              flat
              :to="item.openInNew ? '' : item.to"
              :href="item.openInNew ? item.to : ''"
              :target="item.openInNew ? '_blank' : '_self'"
            >
              <v-img :src="item.src" />
            </v-card>
          </v-col>
        </v-row>
      </v-sheet>

      <Gallery :portal="true"></Gallery>

      <v-sheet height="200"></v-sheet>
    </div>
  </div>
</template>

<script>
// import { VueMasonryPlugin } from "vue-masonry";
import axios from "axios";
import Gallery from "@/views/tailor/gallery";
import NewsWidget from "@/views/news/newsWidget";
import { VueAgile } from "vue-agile"; //バナー用カルーセル
import Add01 from "@/components/add/Add01";

export default {
  name: "PortalTop",
  components: {
    Gallery,
    NewsWidget,
    agile: VueAgile,
    Add01,
  },
  data() {
    return {
      miniBannerList: [
        {
          id: "1",
          src:
            "https://assets.alpaca-connect.com/image/banner/2023-10-17_002.webp",
          alt: "アルパカ社長の公式X",
          to: "https://twitter.com/alpaca_connect",
          openInNew: true,
        },
        {
          id: "2",
          src:
            "https://assets.alpaca-connect.com/image/banner/2023-10-18_001.webp",
          alt: "マスター＆クリエイター募集",
          to: { name: "recruitingForm" },
          openInNew: false,
        },
        {
          id: "3",
          src:
            "https://assets.alpaca-connect.com/image/banner/2023-10-17_001.webp",
          alt: "オフ会情報",
          to: { name: "campaign", params: { cpId: "offlineMeeting" } },
          openInNew: false,
        },
      ],

      userId: "",
      volumn: Number,
      showFooter: false,
      showChoices: true,

      myOptions: {
        navButtons: false,
        infinite: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 600,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              navButtons: true,
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 820,
            settings: {
              centerMode: true,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1400,
            settings: {
              centerMode: true,
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 2000,
            settings: {
              centerMode: true,
              slidesToShow: 4,
            },
          },
        ],
      },
      banners: [],
      loading: false,
    };
  },

  deactivated() {
    this.showChoices = false;
  },
  activated() {
    this.showChoices = true;
  },

  created() {
    //Portal header使用
    this.$emit("changeHeaderVisible", true);
    this.$emit("checkWorldView", false);
    this.getBanners();
  },

  methods: {
    getBanners: async function () {
      this.loading = true;
      const frontSideTime = new Date().getTime();
      const item = this.assetsPath + "/p/topBanners.json?" + frontSideTime;
      const _this = this;
      await axios.get(item).then((response) => {
        if (typeof response.data == "object") {
          _this.banners = response.data;
        }
        this.loading = false;
      });
      this.$nextTick(function () {
        this.$refs.carousel.reload();
      });
    },

    image_path: function (name) {
      return require("@/static/" + name);
    },

    changeFooterShow(footerDisable) {
      this.showFooter = footerDisable;
    },

    getFinalVolumn(volumn) {
      this.volumn = volumn;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.pTop {
  background-color: var(--white);
  &-Container {
    @include baseBox;
    max-width: inherit;
  }
  &-Bunner {
    width: 100%;
    max-width: 600px;
    height: 100%;
  }
}

//カルーセル用スタイル
::v-deep .agile {
  &__actions {
    margin-top: 8px;
  }
  &__nav-button {
    font-size: 24px;
    color: #ccc;
    cursor: pointer;
    background: transparent;
    border: none;
    transition-duration: 0.3s;
  }
  &__nav-button:hover {
    color: #888;
  }
  &__dot {
    margin: 0 10px;
  }
  &__dot button {
    display: block;
    width: 10px;
    height: 10px;
    padding: 0;
    margin: 0;
    font-size: 0;
    line-height: 0;
    cursor: pointer;
    background-color: #ddd;
    border: none;
    border-radius: 50%;
    transition-duration: 0.3s;
  }
  &__dot--current button,
  &__dot:hover button {
    background-color: #888;
  }
  @include media(820px) {
    &__slides--regular {
      padding-left: 25%;
    }
  }
  @include media(1400px) {
    &__slides--regular {
      padding-left: 0;
    }
  }
}
::v-deep .slide {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #f1c40f;
  h3 {
    font-size: 32px;
    font-weight: 300;
  }
}
</style>
